export const mData = [
    {
        title: "📌About Us",
        body: `Banjir Mission is a student led initiative from INTI
         International College Subang created to raised awareness and 
         funds to help MRA in their Misi Banjir Campaign. Our target donation
          amount is RM1000 in 14 weeks duration as part of a MPU (Mata Pelajaran
             Umum) project. As of January 4th 2022, MRA (Malaysia Relief Agency)
              required another RM5 million to aid the victims of the flood in Malaysia.
               With your help, we can bring MRA closer to their goals and potentially improve 
               the lives of the flood victims!`
    },
    {
        id: "mra",
        url: "https://www.hss.mra.my/hss-start-0.0.1-SNAPSHOT/my/relief/agency",
        title: "📌Malaysia Relief Agency (MRA)",
        image: "https://res.cloudinary.com/myjiran/image/upload/v1611552405/org_logo/wl21i3ovar1zxlgnxvdy.png",
        body: "Malaysia Relief Agency or MRA for short is a non-profit humanitarian organization in Malaysia that aids to those affected by natural disasters like the recent floods in Malaysia."
    }
]